// extracted by mini-css-extract-plugin
export default {"menuButton":"navbar_menuButton__awbTE","slidingMenu":"navbar_slidingMenu__plI4G","navLinks":"navbar_navLinks__hMc3j","socialMedia":"navbar_socialMedia__PGwvK"};